export enum ApplicationType {
  DEPOSIT_PAGE = 'webAppDepositPage',
  DEPOSIT_MODAL = 'webAppDepositModal',
  VERIFICATION_PAGE = 'webAppVerificationPage',
  VERIFICATION_MODAL = 'webAppVerificationModal',
}
